import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { Router } from '@angular/router';
import { AutoTrainingCodeModel } from '../../../communication-structure/auto-training-code-model';
import { EditAutoTrainingCodeRequestModel } from '../../../communication-structure/edit-auto-training-code-request-model';
import { GetAtcResponseModel } from '../../../communication-structure/get-atc-response-model';
import { SelectListTypeForEdit } from '../../../communication-structure/select-list-type-for-edit';
import { TrainingsInAutoTrainingCodeFullModel, TrainingsInAutoTrainingCodeModel } from '../../../communication-structure/trainings-in-auto-training-code-list';
import { CommunicationProxyService } from '../../../services/communication-proxy.service';
import { LoginService } from '../../../services/login.service';
import { StringTableService } from '../../../services/string-table.service';
import { DropdownComponent } from '../../dropdown/dropdown.component';
import { ButtonModel, TgButtonComponent } from '../../tg-button/tg-button.component';
import { activeTrainingPageEnum, TrainingManagementComponent } from '../training-management/training-management.component';
import { CreateAutoTrainingCodeComponent } from './../create-auto-training-code/create-auto-training-code.component';
import { MainComponent } from '../../main-component/main.component';

@Component({
  selector: 'app-edit-auto-training-code',
  templateUrl: './../create-auto-training-code/create-auto-training-code.component.html',
  styleUrls: ['./../create-auto-training-code/create-auto-training-code.component.scss']
})

export class EditAutoTrainingCodeComponent extends CreateAutoTrainingCodeComponent implements OnInit {
  systemIdToSend: string;
  public inactivateBtn: ButtonModel = { name: '', icon: '' };
  public reactivateBtn: ButtonModel = { name: '', icon: '' };
  public saveBtn: ButtonModel = { name: '', icon: '' };
  public pageTitle: string;
  private getClientATCListEndPoint: string;
  private getAtcEndPoint: string;
  private editAtcEndPoint: string;
  autoTrainingData: Array<{ id: string, name: string }>;
  clientAtcListDataFromApi: Array<AutoTrainingCodeModel>;
  private dataFormGetAtcCall: GetAtcResponseModel;
  saveBtnClicked: boolean;
  inactiveAtcName;
  @ViewChild('atcNameDD') atcNameDDEle: DropdownComponent;
  @Input() reactivateBtnVisible = false;
  @Input() autoTrainingCodeNameToEdit = '';
  @Output() editingCanceled: EventEmitter<any> = new EventEmitter<any>();
  @Input() trainingStatus: string;

  constructor(
    ele: ElementRef,
    remoteProxy: CommunicationProxyService,
    protected loginService: LoginService,
    stringTableService: StringTableService,
    protected router: Router
  ) {
    super(ele, remoteProxy, loginService, stringTableService, router);
    this.isEdit = true;
  }

  ngOnInit() {
    this.initialiseView();
    this.getClientTrainingList();
    this.initApiCalls();
    if (this.trainingStatus === "Active") {
      this.reactivateBtnVisible = false;
    }
    else {
      this.reactivateBtnVisible = true;
    }
  }

  initApiCalls() {
    if (!this.reactivateBtnVisible) {
      this.getClientAtcList('1');
    } else {
      this.loadDefaultData(this.autoTrainingCodeNameToEdit);
    }
  }

  initialiseView() {
    super.initialiseView();
    let component = 'editInactiveAutoTrainingCode';
    if (this.trainingStatus === "Active") {
      component = 'editAutoTrainingCode';
      this.inactivateBtn.icon = this.stringTableService.getString('icons', 'diff-ignored');
      this.inactivateBtn.name = this.stringTableService.getString('labels', 'inActivate');
    } 
    this.inactiveAtcName = this.stringTableService.getString(component,"inactiveAtcName");
    this.pageTitle = this.stringTableService.getString(component, 'pageTitle');
    this.pageDesc = this.stringTableService.getString(component, 'pageDesc');
    this.reactivateBtn.icon = this.stringTableService.getString('icons', 'check-circle');
    this.reactivateBtn.name = this.stringTableService.getString('labels', 'reActivate');
    this.getAtcEndPoint = this.stringTableService.getEndpoint('GetAtc');
    this.editAtcEndPoint = this.stringTableService.getEndpoint('EditAtc');
    this.getClientATCListEndPoint = this.stringTableService.getEndpoint('GetClientATCList');
    this.saveBtn.icon = this.stringTableService.getString('icons', 'task');
    this.saveBtn.name = this.stringTableService.getString('labels', 'save');
  }

  getClientAtcList(activeStatus) {
    this.getDataFromApi(this.getClientATCListEndPoint, { clientId: this.currentUserClientID, active: activeStatus })
      .subscribe(
      this.handleClientAtcListData.bind(this),
      this.handleSubscriptionError.bind(this, this.getClientAtcList.bind(this), false)
      );
  }

  handleClientAtcListData(data) {
    this.hideLoader();
    this.autoTrainingData = [];
    this.clientAtcListDataFromApi = data.autoTrainingCodeList;
    for (const record of this.clientAtcListDataFromApi) {
      this.autoTrainingData.push({ id: record.autoTrainingCodeId, name: record.autoTrainingCodeName });
    }
    if(this.autoTrainingData.length !== 0)
      this.loadDefaultData(this.autoTrainingData[0].name);
  }

  loadDefaultData(autoTrainingName) {
    this.getAtc(autoTrainingName);
    this.autoTrainingCodeNameToEdit = autoTrainingName;
  }

  getAtc(autoTrainingName) {
    this.getDataFromApi(this.getAtcEndPoint, { clientId: this.currentUserClientID, autoTrainingCodeName: autoTrainingName })
      .subscribe(this.handleAtcData.bind(this),
      this.handleSubscriptionError.bind(this, this.getAtc.bind(this, autoTrainingName), false));
  }

  handleAtcData(data) {
    this.hideLoader();
    this.dataFormGetAtcCall = data;
    if (data.system === 'Windows Only') {
      this.systemIdToSend = this.windowsOnlySystemID;
    } else {
      this.systemIdToSend = this.systemID;
    }
    this.isRegistered = data.isRegistered;
    this.trainingDesc.setText(data.description);
    this.startDateEl.datePicker.writeValue(this.formatDate(this.dateConversion(data.creationDate)));
    this.startDateEl.datePicker.onUserDateInput(this.formatDate(this.dateConversion(data.creationDate)));
    this.endDateEl.datePicker.onUserDateInput(this.formatDate(this.dateConversion(data.expirationDate)));
    this.selectedFreq = data.reminderFrequency;
    const dataForSelectList: {
      application: string,
      title: string,
      skill: string,
      skillId : string,
      assignment: string,
      autoTrainingCode: TrainingsInAutoTrainingCodeModel
    } = {
        application: '',
        title: '',
        skill: '',
        skillId: '',
        assignment: '',
        autoTrainingCode: new TrainingsInAutoTrainingCodeModel()
      };

    const arrListData = [];
    for (const autoTrainingCode of data.trainingsInAutoTrainingCodeList) {
      dataForSelectList.title = autoTrainingCode.title;
      dataForSelectList.application = autoTrainingCode.application;
      dataForSelectList.assignment = autoTrainingCode.assignment;
      dataForSelectList.skill = autoTrainingCode.skill;
      dataForSelectList.skillId = autoTrainingCode.skillId;
      dataForSelectList.autoTrainingCode = autoTrainingCode;
      arrListData.push(Object.assign({}, dataForSelectList));
    }
    this.selectListFill(arrListData);
      this.setInitFocus(this.trainingNameBox);
  }

  setInitFocus(element) {
    setTimeout(() => {
      element.setFocus();
    }, 100);
  }

  selectListFill(listOfItems) {
    this.list.addList(listOfItems);
  }

  activate() {
    if (this.isValidate()) {
      let popupTitle = 'inactivateAtcTitle';
      let popupMsg = 'inactivateAtcDesc';
      if (this.reactivateBtnVisible) {
        popupTitle = 'reactivateAtcTitle';
        popupMsg = 'reactivateAtcDesc';
      }
      const dataForDialog = {
        title: this.stringTableService.getString('popupMessages', popupTitle),
        body: this.stringTableService.getString('popupMessages', popupMsg)
      };
      this.showDialog(dataForDialog, this.callEditAtc.bind(this, this.reactivateBtnVisible, false));
    }
  }

  callEditAtc(activeFlag) {
    this.editAtc(activeFlag);
  }

  onCancelBtnClicked() {
      this.showInactivateHome();
  }

  showInactivateHome() {
    this.router.navigate(['inactive-autotraining']);
  }

  /**
   * send a request to fetch ATC from the server to edit at a later stage
   * @param menuItem ID of the Autotest which was selected
   */
  onMenuItemChange(menuItem) {
    this.autoTrainingCodeNameToEdit = menuItem.name;
    this.list.clearTrainingList();
    this.getAtc(menuItem.name);
  }

  editAtc(activeFlag) {
    if (this.isValidate()) {
      const dataForEditAtc: EditAutoTrainingCodeRequestModel = {
        clientId: this.currentUserClientID,
        system: this.systemIdToSend,
        autoTrainingCodeName: this.autoTrainingCodeNameToEdit,
        creationDate: this.startDate.date,
        expirationDate: this.endDate.date,
        forceOrder: true,
        active: activeFlag,
        proctoreActive: this.dataFormGetAtcCall.proctoredActive,
        description: this.trainingDesc.text,
        reminderFrequency: this.selectedFreq,
        trainingsInAutoTrainingCodeList: this.prepareDataForEditAtc(this.list.lists as SelectListTypeForEdit[], this.defaultCutoffTime)
      };
      this.postDataToApi(this.editAtcEndPoint, dataForEditAtc)
        .subscribe(this.handleEditAtcSuccess.bind(this),
        this.handleSubscriptionError.bind(this, this.editAtc.bind(this, this.reactivateBtnVisible), true));
    }
  }

  handleEditAtcSuccess() {
    this.hideLoader();
    this.validationPopup = true;
    
    if (this.saveBtnClicked) {
      this.showDialog({
        title: this.stringTableService.getString('popupMessages', 'atcSaveTitle'),
        body: this.autoTrainingCodeNameToEdit + ' ' + this.stringTableService.getString('popupMessages', 'atcSaveDesc')
      });
      this.saveBtnClicked = false;
    } else if (this.reactivateBtnVisible) {
      this.showDialog({
        title: this.stringTableService.getString('popupMessages', 'atcActiveTitle'),
        body: this.autoTrainingCodeNameToEdit + ' ' + this.stringTableService.getString('popupMessages', 'atcActiveDesc')
      }, () => {
        this.showInactivateHome();
      });
    } else if (!this.reactivateBtnVisible) {
      this.showDialog({
        title: this.stringTableService.getString('popupMessages', 'atcInactiveTitle'),
        body: this.autoTrainingCodeNameToEdit + ' ' + this.stringTableService.getString('popupMessages', 'atcInactiveDesc')
      }, () => {
        this.showInactivateHome();
      });
    }
  }

  resetAtcEditData() {
    this.atcNameDDEle.resetDropDownTextBox();
    this.list.resetSelectionList();
    this.trainingDesc.resetTextBox();
    this.initApiCalls();
  }

  onSaveBtnClicked() {
    this.saveBtnClicked = true;
    this.editAtc(!this.reactivateBtnVisible);
  }
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/training-management/edit-auto-training-code/edit-auto-training-code.component.ts